var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('form-component',{attrs:{"shop":_vm.shop},on:{"onSubmit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }